import React from "react";

const HOURS_TO_GREETING = [
    { start: 5, end: 12, text: "Buongiorno" },
    { start: 12, end: 18, text: "Buon pomeriggio" },
    { start: 18, end: 24, text: "Buonasera" },
    { start: 0, end: 5, text: "Buonanotte" },
];

function pickGreeting(hour) {
    for (const g of HOURS_TO_GREETING) {
        if (hour >= g.start && hour < g.end) return g.text;
    }
    return "Ciao";
}

function formatDate(d) {
    return d.toLocaleDateString("it-IT", {
        weekday: "long", day: "numeric", month: "long", year: "numeric",
    }).toUpperCase();
}

/**
 * SmartGreeting — greeting + data + riga contestuale KPI.
 *
 * Props:
 *  - user: { name }
 *  - metrics: { ticket_open?: number, scadenze_7d?: number, docs_review?: number }
 *  - onNumberClick: (kind) => void  — click su un numero → naviga
 */
export default function SmartGreeting({ user, metrics = null, onNumberClick = null }) {
    const now = new Date();
    const first = (user?.name || "").split(" ")[0] || "";
    const greeting = pickGreeting(now.getHours());
    const dateStr = formatDate(now);

    const items = [];
    if (metrics) {
        const t = metrics.ticket_open || 0;
        const s = metrics.scadenze_7d || 0;
        const d = metrics.docs_review || 0;
        if (t > 0) items.push({ kind: "tickets", n: t, singular: "ticket aperto", plural: "ticket aperti" });
        if (s > 0) items.push({ kind: "scadenze", n: s, singular: "scadenza in arrivo", plural: "scadenze in arrivo" });
        if (d > 0) items.push({ kind: "docs", n: d, singular: "documento da verificare", plural: "documenti da verificare" });
    }

    const allZero = metrics && items.length === 0;

    return (
        <header className="enl-greeting" data-testid="smart-greeting">
            <h1 data-testid="smart-greeting-heading">
                {greeting}, {first || "benvenuta"}
            </h1>
            <div className="enl-greeting-date" data-testid="smart-greeting-date">
                {dateStr}
            </div>
            {allZero && (
                <div className="enl-greeting-ok" data-testid="smart-greeting-sub-ok">
                    Tutto sotto controllo <span className="spark">✦</span>
                </div>
            )}
            {items.length > 0 && (
                <div className="enl-greeting-sub" data-testid="smart-greeting-sub">
                    {items.map((it, idx) => (
                        <React.Fragment key={it.kind}>
                            {idx > 0 && <span aria-hidden> · </span>}
                            {onNumberClick ? (
                                <button
                                    type="button"
                                    className="sub-link"
                                    onClick={() => onNumberClick(it.kind)}
                                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer", font: "inherit", color: "inherit" }}
                                    data-testid={`smart-greeting-sub-${it.kind}`}
                                >
                                    <span className="num">{it.n}</span> {it.n === 1 ? it.singular : it.plural}
                                </button>
                            ) : (
                                <span>
                                    <span className="num">{it.n}</span> {it.n === 1 ? it.singular : it.plural}
                                </span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            )}
        </header>
    );
}
